<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch" class="transcription-info-dialog">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
    <div fxFlex>Recording Transcription</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <mat-dialog-content fxFlex class="mat-typography transcription-info-dialog__main-info">
    <div fxLayout="column" fxGap="10px">
      <div style="margin-left: 20px">
        <div
          *ngIf="sentimentInfo?.sentiment"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="transcription-info-dialog__info"
        >
          <span><strong>Sentiment:</strong></span>
          <div style="margin-left: 10px">
            <transcript-sentiment-icon [sentiment]="sentimentInfo?.sentiment"></transcript-sentiment-icon>
          </div>
        </div>

        <div *ngIf="sentimentInfo?.score" class="transcription-info-dialog__info">
          <span><strong>Sentiment Score:</strong> {{ sentimentInfo?.score }}</span>
        </div>

        <div class="transcription-info-dialog__info">
          <span><strong>Transcription Confidence Score:</strong> {{ transcriptInfo?.confidence }}</span>
        </div>
      </div>

      <mat-accordion [multi]="true">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Summary</mat-panel-title>
          </mat-expansion-panel-header>
          <p style="padding: 10px">{{ summaryInfo?.summary }}</p>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Transcript Sentiment Viewer</mat-panel-title>
          </mat-expansion-panel-header>

          <div style="max-height: 430px; overflow: auto">
            <transcript-paragraph
              *ngFor="let paragraph of transcriptInfo?.paragraphs || []"
              [paragraph]="paragraph"
            ></transcript-paragraph>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Close</button>
  </mat-dialog-actions>
</div>
